<template>
  <div class="pt-2 mb-5">
    <div class="columns">
      <div class="header-left column">
        <div class="is-flex is-align-items-center mb-2">
          <button
            class="button is-white back-btn mr-2"
            type="button"
            :title="$t('back').capitalize()"
            @click="goBack"
          >
            <b-icon icon="arrow-left" />
          </button>
          <h1 class="title is-4 mb-0">
            {{ $t("public_page_title").capitalize() }}
          </h1>
        </div>
        <p class="is-custom-grey">
          <b-icon
            icon="map-marker"
            size="is-small"
          />
          {{ $shortStreet(model.address.address_1)
          }}{{ model.address.address_2 ? ` #${model.address.address_2}` : "" }},
          {{ model.address.city }}
        </p>
      </div>

      <div class="header-right column">
        <div class="is-flex is-justify-content-flex-start is-flex-direction-column">
          <div class="has-text-right has-text-left-mobile">
            <p class="title has-text-weight-medium is-2 mb-2">
              <template v-if="hasDiscount">
                <span class="regular-price-struck">{{ model.promotion_details.regular_price }}$</span>
                <span>{{ model.promotion_details.display_price }}$</span>
              </template>
              <template v-else>
                {{ model.latest_status.asked_rent }}$
              </template>
            </p>
            <span
              v-if="model.promotion_details"
              class="promo-badge"
            >
              {{ promoLabel }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
  methods: {
    // Back to the listing, keeping its filters (they live in the URL); direct
    // visitors with no history land on the listing root instead.
    goBack() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push("/");
      }
    },
  },
  computed: {
    hasDiscount() {
      return (
        this.model.promotion_details &&
        this.model.promotion_details.display_price < this.model.promotion_details.regular_price
      );
    },
    // "Mois gratuit" for free-month promos, "Promotion" otherwise — same
    // wording as the card banner.
    promoLabel() {
      return this.model.promotion_details.type === "free_month"
        ? this.$t("promotion_free_month_banner")
        : this.$t("promotion").capitalize();
    },
  },
};
</script>
<style lang="scss" scoped>
$promotion-red: #e02b2b;

// Framed promotion label under the price
.promo-badge {
  display: inline-block;
  border: 2px solid $promotion-red;
  color: $promotion-red;
  font-weight: 700;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-radius: 6px;
  padding: 2px 10px;
}

// The display font renders line-through below the visual middle, so draw the
// strike ourselves, dead-center on the digits.
.regular-price-struck {
  position: relative;
  display: inline-block;
  color: #9a9a9a;
  font-weight: 400;
  font-size: 0.6em;
  vertical-align: middle;
  margin-right: 0.5rem;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    // 50% of the box is below the digits' middle (descender space); shift up
    // to the numerals' visual center.
    top: calc(50% - 0.09em);
    transform: translateY(-50%);
    border-top: 3px solid #b5b5b5;
  }
}
</style>
